var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBurger = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.749981 1.49996H23.25C23.664 1.49996 23.9999 1.16394 23.9999 0.749981C23.9999 0.335964 23.6639 0 23.25 0H0.749981C0.335964 0 0 0.336027 0 0.749981C0 1.16394 0.336026 1.49996 0.749981 1.49996Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.25H0.749981C0.335964 5.25 0 5.58602 0 5.99998C0 6.41393 0.336026 6.74995 0.749981 6.74995H23.25C23.664 6.74995 23.9999 6.41393 23.9999 5.99998C23.9999 5.58602 23.664 5.25 23.25 5.25Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 10.5H8.24998C7.83596 10.5 7.5 10.836 7.5 11.25C7.5 11.664 7.83603 12 8.24998 12H23.25C23.664 12 23.9999 11.6639 23.9999 11.25C24 10.836 23.664 10.5 23.25 10.5Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burger.ac85325b.svg";
export { ForwardRef as ReactComponent };